import { createFieldInput, createFieldTextArea } from "../../../../../components/input/template-builder/template-builder.logic";
import { createColumnInput, createColumnTextTruncate } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import lodash from "lodash";

export const methods = ["GET", "POST", "PUT", "DELETE"];

export const methodToArray = ({ method }) => method?.split(",").map(d => d.trim().toUpperCase()) || [];

export const hasMethod = ({ model, method }) => methodToArray({ method: model.method }).includes(method);

export const onChangeMethod = ({ model, checked, method }) => {
    let methodsTmp = methodToArray({ method: model.method });
    if (checked) {
        methodsTmp.push(method);
    } else {
        methodsTmp = methodsTmp.filter(d => d !== method);
    }
    methodsTmp.sort();
    model.method = methodsTmp.join(", ") || null;
};

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.resource.name"), dataIndex: "name" }),
        createColumnInput({ title: () => i18n.global.t("model.resource.desc"), dataIndex: "desc" }),
        createColumnInput({ title: () => i18n.global.t("model.resource.method"), dataIndex: "method" }),
        createColumnInput({ title: () => i18n.global.t("model.resource.url"), dataIndex: "url" }),
        createColumnTextTruncate({ title: () => i18n.global.t("model.resource.attribute"), dataIndex: "attribute", sorter: false })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}name`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.resource.name"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.name, "onUpdate:value": value => (model.name = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}desc`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.resource.desc"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.desc, "onUpdate:value": value => (model.desc = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}method`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.resource.method"),
                inputRender: () => {
                    return (
                        <>
                            {methods.map(method => (
                                <Checkbox
                                    checked={hasMethod({ model, method })}
                                    onChange={e => onChangeMethod({ model, checked: e.target.checked, method })}
                                    disabled={viewOnly}
                                >
                                    {method}
                                </Checkbox>
                            ))}
                        </>
                    );
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}url`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.resource.url"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.url, "onUpdate:value": value => (model.url = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}attributeStr`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.resource.attribute"),
                inputProp: ({ field }) => {
                    const onBlur = () => {
                        try {
                            model.attribute = JSON.parse(model.attributeStr);
                            model.attributeStr = JSON.stringify(model.attribute, null, 4);
                        } catch (error) {
                            error;
                        }
                        useForm.validate("attributeStr").catch(() => {});
                    };
                    return lodash.merge(
                        {
                            value: model.attributeStr,
                            "onUpdate:value": value => (model.attributeStr = value),
                            rows: 6,
                            onBlur,
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            })
        ]
    });
};
